import colorCG3 from "./etc/colors.cg3";
import stylesCG3 from "./etc/styles.cg3";
import {ConfigParser} from "../web/parser";

const colors =  new ConfigParser(colorCG3, {}).parse();
const styles = new ConfigParser(stylesCG3, {}).parse();

export {colors, styles};